import { useErrorBoundary } from 'react-error-boundary';
import LdsButton from '../LdsButton/index.jsx';

export default function FallbackRender({
  resetButton,
  errorMessagePrefix,
  buttonText = 'Try again',
  error,
}) {
  const { resetBoundary } = useErrorBoundary();

  return (
    <div role="alert">
      <p>{errorMessagePrefix}</p>
      <pre style={{ color: 'red' }}>{error.message}</pre>
      {resetButton && (
        <LdsButton onClick={resetBoundary}>{buttonText}</LdsButton>
      )}
    </div>
  );
}
